import { FORM_STATUS, FIELD_STATUS, API_CALL_STATUS } from '../status';
import {
    FROM_CURRENCY_SET_VALUE,
    FROM_CURRENCY_SET_VALID,
    TO_CURRENCY_SET_VALUE,
    TO_CURRENCY_SET_VALID,
    EXCHANGE_RATE_SET_VALUE,
    EXCHANGE_RATE_SET_VALID,
    LAST_UPDATED_EXCHANGE_RATE_SET_VALID,
    LAST_UPDATED_EXCHANGE_RATE_SET_VALUE,
    ACTIVE_EXCHANGE_RATE_SET_VALUE,
    ACTIVE_EXCHANGE_RATE_SET_VALID,
    API_PENDING_TRIGGER_UPDATE,
    API_FAILURE_TRIGGER_UPDATE,
    API_SUCCESS_TRIGGER_UPDATE,
    TRIGGER_UPDATE_SUCCESS,
    TRIGGER_UPDATE_FAILURE,
    GET_EXCHANGE_LIST_SUCCESS,
    GET_EXCHANGE_LIST_FAILURE,
    API_SUCCESS_GET_EXCHANGE_LIST,
    API_PENDING_GET_EXCHANGE_LIST,
    API_FAILURE_GET_EXCHANGE_LIST,
    REINITIALIZE,
} from '../../actions/eaTravelRates/update';

export const initUpdate = {
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    updateApiCallStatus: null,
    updateStatusData: null,
    exchangeListApiCallStatus: null,
    exchangeData: null,
    form: {
        fromCurrency: { value: null, error: null, status: null },
        toCurrency: { value: null, error: null, status: null },
        exchangeRate: { value: null, error: null, status: null },
        activeExchangeRate: { value: null, error: null, status: null },
        lastUpdatedExchangeRate: { value: null, error: null, status: null },
    },
};

export default (state = initUpdate, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FROM_CURRENCY_SET_VALUE:
            return updateFormField('fromCurrency', (field) => ({
                ...field,
                value: action.value,
            }));
        case FROM_CURRENCY_SET_VALID:
            return updateFormField('fromCurrency', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case TO_CURRENCY_SET_VALUE:
            return updateFormField('toCurrency', (field) => ({
                ...field,
                value: action.value,
            }));

        case TO_CURRENCY_SET_VALID:
            return updateFormField('toCurrency', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EXCHANGE_RATE_SET_VALUE:
            return updateFormField('exchangeRate', (field) => ({
                ...field,
                value: action.value,
            }));
        case EXCHANGE_RATE_SET_VALID:
            return updateFormField('exchangeRate', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ACTIVE_EXCHANGE_RATE_SET_VALUE:
            return updateFormField('activeExchangeRate', (field) => ({
                ...field,
                value: action.value,
            }));
        case ACTIVE_EXCHANGE_RATE_SET_VALID:
            return updateFormField('activeExchangeRate', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case LAST_UPDATED_EXCHANGE_RATE_SET_VALUE:
            return updateFormField('lastUpdatedExchangeRate', (field) => ({
                ...field,
                value: action.value,
            }));
        case LAST_UPDATED_EXCHANGE_RATE_SET_VALID:
            return updateFormField('lastUpdatedExchangeRate', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case API_PENDING_TRIGGER_UPDATE:
            return { ...state, updateApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRIGGER_UPDATE:
            return { ...state, updateApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRIGGER_UPDATE:
            return { ...state, updateApiCallStatus: API_CALL_STATUS.FAILURE };

        case TRIGGER_UPDATE_SUCCESS:
            return { ...state, updateStatusData: action.data };

        case TRIGGER_UPDATE_FAILURE:
            return { ...state, updateStatusData: null };

        case API_PENDING_GET_EXCHANGE_LIST:
            return { ...state, exchangeListApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_GET_EXCHANGE_LIST:
            return { ...state, exchangeListApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_GET_EXCHANGE_LIST:
            return { ...state, exchangeListApiCallStatus: API_CALL_STATUS.FAILURE };

        case GET_EXCHANGE_LIST_SUCCESS:
            return { ...state, exchangeData: action.data };

        case GET_EXCHANGE_LIST_FAILURE:
            return { ...state, exchangeData: null };

        case REINITIALIZE:
            return initUpdate;

        default:
            return state;
    }
};
